<article class="main-app-wrapper">
  <perfect-scrollbar [config]="config" [scrollIndicators]="true">
    <div id="timeline" *ngIf="data" fxLayout="column">
      <div class="timeline-wrapper">
        <div class="ms-timeline-item" *ngFor="let history of data.allHistory">
          <div class="timeline-card">
            <mat-card appearance="outlined" class="mat-card-history">
              <div class="card-header-container">
                <ng-container
                  *ngTemplateOutlet="
                    updatedBy;
                    context: {
                      updatedByUser: history.updated_by.name,
                      updatedByCompany: history.updated_by.company,
                      link: history.updated_by?.link?.url
                    }
                  "
                ></ng-container>
              </div>

              <ng-container *ngTemplateOutlet="breakLine"></ng-container>

              <div class="card-container">
                <ng-container *ngFor="let historyChange of history.changes">
                  <div class="__item">
                    <ng-container
                      *ngTemplateOutlet="historyDetails; context: { $implicit: historyChange }"
                    ></ng-container>
                  </div>
                  <ng-container *ngTemplateOutlet="breakLine"></ng-container>
                </ng-container>
              </div>
            </mat-card>
          </div>
          <ng-container *ngTemplateOutlet="centerButton; context: { $implicit: editIcon }"></ng-container>
          <ng-container
            *ngTemplateOutlet="
              userPanel;
              context: {
                date: history.changeDate,
                updatedByUser: history.updated_by.name,
                updatedByCompany: history.updated_by.company,
                link: history?.updated_by?.link?.url
              }
            "
          ></ng-container>
        </div>
        <div class="ms-timeline-item" *ngIf="data.createProduct && data.createProduct.created_by">
          <div class="timeline-card"></div>
          <ng-container *ngTemplateOutlet="centerButton; context: { $implicit: addIcon }"></ng-container>
          <ng-container
            *ngTemplateOutlet="
              userPanel;
              context: {
                date: data.createProduct.created_on,
                link: data.createProduct.created_by?.link?.url,
                hideDefault: true,
                updatedByUser: data.createProduct?.created_by?.name,
                updatedByCompany: data.createProduct?.created_by?.company,
                dataLabel: 'Created'
              }
            "
          ></ng-container>
        </div>
      </div>
      <div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp">
        <span class="spinner animate-rotate"></span>
      </div>
    </div>
  </perfect-scrollbar>

  <ng-template
    #userPanel
    let-date="date"
    let-updatedByUser="updatedByUser"
    let-updatedByCompany="updatedByCompany"
    let-link="link"
    let-dataLabel="dataLabel"
    let-hideDefault="hideDefault"
  >
    <div class="timeline-detail">
      <div class="event">
        <ng-container *ngIf="dataLabel; else defaultLabel">
          {{ dataLabel }}
        </ng-container>
        <ng-template #defaultLabel>Data edited</ng-template>
      </div>
      <div class="time">
        {{ date | date: 'MMM dd, yyyy hh:mm a' }}
      </div>
      <ng-container
        *ngTemplateOutlet="
          updatedBy;
          context: {
            updatedByUser: updatedByUser,
            updatedByCompany: updatedByCompany,
            link: link,
            hideDefault: hideDefault
          }
        "
      ></ng-container>
    </div>
  </ng-template>

  <ng-template
    #updatedBy
    let-updatedByUser="updatedByUser"
    let-updatedByCompany="updatedByCompany"
    let-link="link"
    let-hideDefault="hideDefault"
  >
    <div class="card-header">
      <span>By</span>
      @if (link) {
        <a aria-label="open createdby profile" role="button" [href]="link | removeHash | newUiRoute: true">
          <mds-chip
            [label]="updatedByUser"
            [icon]="userIcon"
            theme="light"
            [showChipIcon]="true"
            [removable]="false"
          ></mds-chip>
        </a>
      }
      @if (!link) {
        <mds-chip
          [label]="updatedByUser"
          [icon]="userIcon"
          theme="light"
          [showChipIcon]="true"
          [removable]="false"
        ></mds-chip>
      }
      <span
        class="company-name"
        matTooltipHideDelay="300"
        [matTooltip]="updatedByCompany"
        matTooltipClass="tooltip-white"
        *ngIf="updatedByCompany; else defaultCompany"
      >
        {{ updatedByCompany }}
      </span>
      <ng-template #defaultCompany>
        <span class="company-name" matTooltip="from Makersite" matTooltipClass="tooltip-white" *ngIf="!hideDefault">
          from Makersite
        </span>
      </ng-template>
    </div>
  </ng-template>

  <ng-template #breakLine>
    <div class="break-line"></div>
  </ng-template>

  <ng-template #centerButton let-icon>
    <div class="timeline-point md-accent-bg md-whiteframe-2dp elevation-tile">
      <mds-icon [key]="icon" [height]="32" [width]="32" [pathColors]="[primaryColor]"></mds-icon>
    </div>
  </ng-template>
  <ng-template #historyDetails let-historyChange>
    <span class="__header">{{ historyChange.header }}</span>
    <ng-container *ngFor="let item of historyChange.diff">
      <div
        *ngIf="
          item !== '+++ ' &&
          item !== '--- ' &&
          ((!item.includes('@@') && item.charAt(0) == '-') || (!item.includes('@@') && item.charAt(0) == '+'))
        "
      >
        <span>
          <div class="history-item" *ngIf="!item.includes('@@') && item.charAt(0) == '-'">
            <ng-container *ngIf="!historyChange.change; else fields">
              <span class="removed-history">- removed</span>
              <div class="fields">
                <div class="removed">{{ item.replace('-', '') }}</div>
              </div>
            </ng-container>
            <ng-template #fields>
              <span class="removed-history">- removed</span>
              <ng-container
                *ngTemplateOutlet="historyValue; context: { $implicit: historyChange, removed: true }"
              ></ng-container>
            </ng-template>
          </div>
          <div class="history-item" *ngIf="!item.includes('@@') && item.charAt(0) == '+'">
            <ng-container *ngIf="!historyChange.change; else fields">
              <span class="updated-history">+ updated</span>
              <div class="fields">
                <div>{{ item.replace('+', '') }}</div>
              </div>
            </ng-container>

            <ng-template #fields>
              <span class="updated-history">+ updated</span>
              <ng-container *ngTemplateOutlet="historyValue; context: { $implicit: historyChange }"></ng-container>
            </ng-template>
          </div>
        </span>
      </div>
    </ng-container>
  </ng-template>

  <ng-template>
    <div class="updated-history"></div>
  </ng-template>

  <ng-template #historyValue let-historyChange let-removed="removed">
    <div class="fields">
      <div [ngClass]="{ removed: removed }" class="removed" *ngFor="let field of historyChange.change">
        {{ field }}
      </div>
    </div>
  </ng-template>
</article>
